/* GNH Bundle Builder — behaviour for sections/gnh-bundle-builder.liquid.
   One instance per [data-gnh-bb] root; data comes from the JSON script
   [data-bb-data="<section id>"] rendered by the section.
   After add: Zipify cart drawer if present, else Dawn cart drawer, else /cart. */
(function () {
function initBundleBuilder(root) {
  if (!root || root.dataset.bbReady) return;
  root.dataset.bbReady = '1';
  var sid = root.getAttribute('data-gnh-bb');
  var dataEl = document.querySelector('[data-bb-data="' + sid + '"]');
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var fmt = function (cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: D.currency || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var lensOf = function (t) { return (String(t).match(/\d+/g) || []).map(Number); };
  var pretty = function (t) { return String(t).replace(/"/g, '″').replace(/-/g, '/'); };

  // Lookups
  var dealById = {};
  D.deal.variants.forEach(function (v) { v.lens = lensOf(v.title); dealById[v.id] = v; });
  var singleByLen = {};
  if (D.singles) D.singles.variants.forEach(function (v) { v.len = lensOf(v.title)[0]; singleByLen[v.len] = v; });
  var upByBlock = {};
  var fromPrice = { closure: null, frontal: null };
  D.upsells.forEach(function (u) {
    u.variants.forEach(function (v) { v.len = lensOf(v.title)[0] || null; });
    upByBlock[u.block] = u;
    var avail = u.variants.filter(function (v) { return v.available; });
    avail.forEach(function (v) { if (fromPrice[u.kind] === null || v.price < fromPrice[u.kind]) fromPrice[u.kind] = v.price; });
  });
  ['closure', 'frontal'].forEach(function (k) {
    var el = $('[data-bb-from="' + k + '"]');
    if (el && fromPrice[k] !== null) el.textContent = 'From ' + fmt(fromPrice[k]);
  });

  var state = { deal: null, kind: 'none', type: { closure: null, frontal: null }, len: { closure: null, frontal: null }, extra: false, extraLen: null, userLen: { closure: false, frontal: false, extra: false } };

  // ---------- helpers ----------
  function closest(variants, target) {
    var best = null;
    variants.forEach(function (v) {
      if (!v.available) return;
      if (!best) { best = v; return; }
      var d = v.len == null ? 999 : Math.abs(v.len - target), bd = best.len == null ? 999 : Math.abs(best.len - target);
      if (d < bd || (d === bd && v.len < best.len)) best = v;
    });
    return best;
  }
  function currentDeal() { return dealById[state.deal]; }
  function currentUpsell() {
    if (state.kind === 'none') return null;
    var u = upByBlock[state.type[state.kind]];
    if (!u) return null;
    var v = u.variants.filter(function (x) { return x.id === state.len[state.kind]; })[0];
    return v ? { u: u, v: v } : null;
  }
  function currentExtra() { return state.extra ? singleByLen[state.extraLen] || null : null; }

  function renderLengths(kind, variants, selectedId, recLen) {
    var wrap = $('[data-bb-lengths="' + kind + '"]');
    if (!wrap) return;
    wrap.innerHTML = '';
    variants.forEach(function (v) {
      var label = document.createElement('label');
      label.className = 'gnh-bb__opt';
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'bb-len-' + kind + '-' + sid;
      input.value = v.id;
      input.disabled = !v.available;
      input.checked = v.id === selectedId;
      input.addEventListener('change', function () {
        if (kind === 'extra') { state.extraLen = v.len; state.userLen.extra = true; }
        else { state.len[kind] = v.id; state.userLen[kind] = true; }
        update();
      });
      var card = document.createElement('span');
      card.className = 'gnh-bb__card' + (recLen && v.len === recLen && v.available ? ' gnh-bb__rec-dot' : '');
      card.innerHTML = '<span class="gnh-bb__card-main">' + (v.len ? v.len + '″' : 'One size') + '</span><span class="gnh-bb__card-sub">' + (v.available ? fmt(v.price) : 'Sold out') + '</span>';
      label.appendChild(input); label.appendChild(card);
      wrap.appendChild(label);
    });
  }

  function guideText(lens) {
    var max = Math.max.apply(null, lens);
    if (max >= 26) return '<strong>Going ' + max + '″?</strong> For this length most installs use 4+ bundles — add a 4th below for full, even ends.';
    if (max >= 18) return '<strong>3 bundles is the sweet spot</strong> for 18″–24″ — full glam from root to tip.';
    return '<strong>Shorter lengths</strong> look full with 2–3 bundles; this set gives you 3.';
  }

  // ---------- delivery ----------
  function etParts(d) {
    var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' }).formatToParts(d);
    var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, min: +o.minute, wd: o.weekday };
  }
  var noShip = (D.noShip || '').split(/[\s,]+/).filter(Boolean);
  function isShipDay(dt) {
    var wd = dt.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    var iso = dt.toISOString().slice(0, 10);
    return noShip.indexOf(iso) === -1;
  }
  function addShipDays(dt, n) {
    var x = new Date(dt.getTime());
    while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isShipDay(x)) n--; }
    return x;
  }
  function fmtDay(dt) { return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }); }
  function deliveryText(allInStock) {
    if (!allInStock) return 'One item in your install is being restocked — your order ships as soon as it’s back in.';
    var now = new Date();
    var et = etParts(now);
    var today = new Date(Date.UTC(et.y, et.m - 1, et.d));
    var ship;
    var lead = '';
    if (isShipDay(today) && et.h < 12) {
      ship = today;
      var mins = (12 - et.h) * 60 - et.min;
      var h = Math.floor(mins / 60), m = mins % 60;
      lead = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> and it ships <strong>today</strong>. ';
    } else {
      ship = addShipDays(today, 1);
      lead = 'Ships <strong>' + fmtDay(ship) + '</strong>. ';
    }
    var a = addShipDays(ship, 2), b = addShipDays(ship, 3);
    return lead + 'Arrives ' + fmtDay(a) + '–' + fmtDay(b) + ' with Standard shipping.';
  }

  // ---------- main update ----------
  function update() {
    var dv = currentDeal();
    if (!dv) return;
    var lens = dv.lens;
    var shortest = Math.min.apply(null, lens);
    var longest = Math.max.apply(null, lens);

    // guide + low stock
    var g = $('[data-bb-guide]'); if (g) g.innerHTML = guideText(lens);
    var low = $('[data-bb-low]');
    if (low) {
      if (dv.low > 0) { low.hidden = false; low.textContent = 'Only ' + dv.low + ' set' + (dv.low === 1 ? '' : 's') + ' left in ' + pretty(dv.title) + '.'; }
      else low.hidden = true;
    }

    // kind panels
    ['closure', 'frontal'].forEach(function (k) {
      var panel = $('[data-bb-panel="' + k + '"]');
      if (!panel) return;
      panel.hidden = state.kind !== k;
      if (state.kind !== k) return;
      if (!state.type[k]) {
        var def = $('[data-bb-type="' + k + '"][data-bb-default]') || $('[data-bb-type="' + k + '"]');
        if (def) { def.checked = true; state.type[k] = def.value; }
      }
      var u = upByBlock[state.type[k]];
      if (!u) return;
      var ids = u.variants.map(function (v) { return v.id; });
      var rec = closest(u.variants, shortest);
      if (!state.userLen[k] || ids.indexOf(state.len[k]) === -1) state.len[k] = rec ? rec.id : null;
      var sel = u.variants.filter(function (v) { return v.id === state.len[k]; })[0];
      if (sel && !sel.available) { state.len[k] = rec ? rec.id : null; }
      renderLengths(k, u.variants, state.len[k], rec ? rec.len : null);
      var note = $('[data-bb-rec-note="' + k + '"]');
      if (note) note.textContent = !rec || !rec.len ? '' : rec.len === shortest ? '· ' + rec.len + '″ matches your shortest bundle' : '· ' + rec.len + '″ is the closest match to your ' + shortest + '″';
    });
    var kh = $('[data-bb-kind-hint]');
    if (kh) {
      kh.innerHTML = state.kind === 'closure' ? 'A closure covers the part area — the easiest, lowest-maintenance finish.'
        : state.kind === 'frontal' ? 'A frontal covers ear to ear, so you can part anywhere and wear it up.'
        : 'Leave-out install: your own hair blends over the top. Add a closure or frontal for a fully protective style.';
    }

    // extra bundle
    var extraBox = $('[data-bb-extra]');
    if (extraBox && D.singles) {
      var rec4 = longest >= D.extraMinLen;
      $('[data-bb-extra-title]').textContent = 'Add a 4th bundle' + (rec4 ? ' — recommended for ' + longest + '″' : '');
      if (!state.userLen.extra || !singleByLen[state.extraLen]) {
        var cand = D.singles.variants.map(function (v) { return v; });
        var r = closest(cand, longest);
        state.extraLen = r ? r.len : null;
      }
      $('[data-bb-extra-panel]').hidden = !state.extra;
      if (state.extra) renderLengths('extra', D.singles.variants, (singleByLen[state.extraLen] || {}).id, longest);
      var ev = singleByLen[state.extraLen];
      var en = $('[data-bb-extra-note]');
      if (en && ev) en.textContent = (en.dataset.base || (en.dataset.base = en.textContent)) + ' +' + fmt(ev.price) + ' for a ' + ev.len + '″ bundle.';
    }

    // summary
    var items = [{ label: pretty(dv.title) + ' bundle deal', price: dv.price, id: dv.id, instock: dv.instock }];
    var up = currentUpsell();
    if (up) items.push({ label: (up.v.len ? up.v.len + '″ ' : '') + up.u.label + ' ' + up.u.kind, price: up.v.price, id: up.v.id, instock: up.v.instock });
    var ex = currentExtra();
    if (ex) items.push({ label: ex.len + '″ extra bundle', price: ex.price, id: ex.id, instock: ex.instock });
    var total = items.reduce(function (s, i) { return s + i.price; }, 0);

    var lines = $('[data-bb-lines]');
    lines.innerHTML = items.map(function (i) { return '<li><span>' + i.label + '</span><span>' + fmt(i.price) + '</span></li>'; }).join('');
    $('[data-bb-total]').textContent = fmt(total);

    // savings vs singles (deal only, only when real)
    var saveEl = $('[data-bb-save]');
    if (saveEl && D.singles) {
      var sum = 0, ok = true;
      lens.forEach(function (l) { var s = singleByLen[l]; if (s) sum += s.price; else ok = false; });
      var save = ok ? sum - dv.price : 0;
      saveEl.hidden = !(save > 0);
      if (save > 0) saveEl.textContent = 'You save ' + fmt(save) + ' vs. buying these 3 bundles separately';
    }

    // free shipping meter
    if (D.freeShip > 0) {
      var st = $('[data-bb-ship-text]');
      var bar = $('[data-bb-ship-bar]');
      var left = D.freeShip - total;
      if (st) st.innerHTML = left <= 0 ? '<strong>Free shipping unlocked</strong> on this install.' : 'You’re <strong>' + fmt(left) + '</strong> away from free shipping.';
      if (bar) bar.style.width = Math.min(100, Math.round(total / D.freeShip * 100)) + '%';
    }

    var dn = $('[data-bb-discount-note]');
    if (dn) dn.hidden = !(D.discountCode && up && dn.textContent.trim());

    // delivery
    var allIn = items.every(function (i) { return i.instock; });
    var dt = $('[data-bb-delivery-text]'); if (dt) dt.innerHTML = deliveryText(allIn);

    // CTA + sticky
    var ctaLabel = $('[data-bb-cta-label]');
    var base = ctaLabel.dataset.base || (ctaLabel.dataset.base = ctaLabel.textContent.trim());
    ctaLabel.textContent = base + ' — ' + fmt(total);
    $('[data-bb-sticky-total]').textContent = fmt(total);
    $('[data-bb-sticky-desc]').textContent = pretty(dv.title) + (up ? ' + ' + up.u.kind : '') + (ex ? ' + 4th bundle' : '');
    state.items = items;
  }

  // ---------- events ----------
  $$('[data-bb-deal]').forEach(function (r) {
    r.addEventListener('change', function () { state.deal = +r.value; update(); });
  });
  if (!$('[data-bb-kind]:checked') && $('[data-bb-kind][value="none"]')) $('[data-bb-kind][value="none"]').checked = true;
  $$('[data-bb-kind]').forEach(function (r) {
    if (r.checked) state.kind = r.value;
    r.addEventListener('change', function () { state.kind = r.value; update(); });
  });
  $$('[data-bb-type]').forEach(function (r) {
    r.addEventListener('change', function () { state.type[r.dataset.bbType] = r.value; update(); });
  });
  var extraBox = $('[data-bb-extra]');
  if (extraBox) extraBox.addEventListener('change', function () { state.extra = extraBox.checked; update(); });

  // initial deal = popular or first available
  var init = $('[data-bb-deal][data-bb-popular]') || $$('[data-bb-deal]').filter(function (r) { return !r.disabled; })[0];
  if (init) { init.checked = true; state.deal = +init.value; }
  update();
  setInterval(function () { var dt = $('[data-bb-delivery-text]'); if (dt && state.items) dt.innerHTML = deliveryText(state.items.every(function (i) { return i.instock; })); }, 60000);

  // ---------- add to cart ----------
  var busy = false;
  function addToCart() {
    if (busy || !state.items) return;
    busy = true;
    var btns = $$('.gnh-bb__cta');
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var err = $('[data-bb-error]'); err.hidden = true;
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = D.afterAdd === 'drawer' && drawer && typeof drawer.renderContents === 'function';
    var body = {
      items: state.items.map(function (i) { return { id: i.id, quantity: 1, properties: { _source: 'Bundle builder' } }; })
    };
    if (useDrawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    var hasUpsell = state.items.length > 1 && !!currentUpsell();
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Something went wrong. Please try again.');
        var chain = Promise.resolve();
        if (D.discountCode && hasUpsell) {
          chain = fetch('/discount/' + encodeURIComponent(D.discountCode), { credentials: 'same-origin' }).catch(function () {});
        }
        return chain.then(function () {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gnh-bundle-builder', cartData: res.j }); } catch (e) {}
          }
          if (D.afterAdd === 'checkout') { window.location.href = '/checkout'; return; }
          var zc = window.Zipify && window.Zipify.Cart && window.Zipify.Cart.instance;
          if (D.afterAdd === 'drawer' && zc && typeof zc.openUpdatedCart === 'function') {
            zc.openUpdatedCart();
            return;
          }
          if (useDrawer) {
            res.j.id = state.items[0].id;
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.j);
            return;
          }
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        });
      })
      .catch(function (e) { err.textContent = e.message; err.hidden = false; })
      .finally(function () { busy = false; btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  }
  $('[data-bb-form]').addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
  var stickyBtn = $('[data-bb-sticky-cta]');

  // ---------- sticky bar visibility ----------
  var sticky = $('[data-bb-sticky]');
  var cta = $('[data-bb-cta]');
  var builder = $('[data-bb-form]');
  var seenBuilder = false;
  if (sticky && 'IntersectionObserver' in window) {
    var ctaVisible = false;
    var setSticky = function () {
      var show = !ctaVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) {
        stickyBtn.tabIndex = show ? 0 : -1;
        stickyBtn.textContent = seenBuilder ? 'Add to bag' : 'Build my install';
      }
    };
    new IntersectionObserver(function (en) { ctaVisible = en[0].isIntersecting; setSticky(); }).observe(cta);
    new IntersectionObserver(function (en) { if (en[0].isIntersecting) { seenBuilder = true; setSticky(); } }, { threshold: 0.25 }).observe(builder);
  }
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (seenBuilder) { addToCart(); return; }
      builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ---------- reviews link fallback ----------
  var rl = $('.gnh-bb__rating a');
  if (rl && rl.getAttribute('href').charAt(0) === '#') {
    rl.addEventListener('click', function (e) {
      var t = document.querySelector(rl.getAttribute('href')) || document.querySelector('.gnh-rv');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  // ---------- gallery ----------
  var slides = $('[data-bb-slides]');
  var count = $('[data-bb-count]');
  var total = $$('[data-bb-slide]').length;
  var thumbs = $$('[data-bb-thumb]');
  if (slides) {
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      if (count) count.textContent = (i + 1) + ' / ' + total;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', +t.dataset.bbThumb === i ? 'true' : 'false'); });
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { slides.scrollTo({ left: slides.clientWidth * +t.dataset.bbThumb, behavior: 'smooth' }); });
    });
  }
}
function initAll() { document.querySelectorAll('[data-gnh-bb]').forEach(initBundleBuilder); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
document.addEventListener('shopify:section:load', initAll);
})();
